import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';

const CalendarDayCell = ({ dayCellInfo, events, currentView }) => {
  const date = dayCellInfo.date;

  // Filter events that match the specific date
  const dayEvents = events.filter(event => new Date(event.start).toDateString() === date.toDateString());
  const uniqueAppointmentIds = new Set(dayEvents.map(event => event.appointmentId));
  const uniqueAppointmentCount = uniqueAppointmentIds.size;

  if (currentView === 'dayGridMonth') {
    return (
      <motion.div
        key={currentView}
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: -50 }}
        transition={{ duration: 0.3 }}
        style={{
          width: '100%',
          height: '100%',
          position: 'relative', // Make relative for absolute children
        }}
      >
        {/* Date number at the top center */}
        <div
          style={{
            textAlign: 'center',
            fontWeight: 500,
            position: 'relative',
            zIndex: 2
          }}
        >
          {date.getDate()}
        </div>
        {/* Centered appointment count below date number */}
        {uniqueAppointmentCount > 0 && (
          <Box
            sx={{
              backgroundColor: 'red',
              color: 'white',
              borderRadius: '50%',
              width: 24,
              height: 24,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '0.85rem',
              position: 'absolute',
              left: '50%',
              top: '26px', 
              transform: 'translateX(-50%)',
              zIndex: 1,
              fontWeight: 600,
              boxShadow: '0 1px 6px 0 rgba(0,0,0,0.08)'
            }}
          >
            {uniqueAppointmentCount}
          </Box>
        )}
      </motion.div>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <div>{date.getDate()}</div>
    </Box>
  );
};

export default CalendarDayCell;